import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'api/axios';
import { updateBalances } from './authSlice';

const initialState = {
  error: null as string | null,
};

export const redeemPromoCode = createAsyncThunk(
  'bonus/redeemPromoCode',
  async (code: string, { dispatch, rejectWithValue }) => {
    try {
      const res = await axiosInstance.post('/client/promo-codes/use', { code });
      if (res.status === 200) {
        const data = res?.data?.data;
        if (data?.balances) {
          dispatch(updateBalances(data));
        }
        return data ?? null;
      }
      return null;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || 'Failed to redeem promo code.');
    }
  },
);

const bonusSlice = createSlice({
  name: 'bonus',
  initialState,
  reducers: {
    clearBonusError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(redeemPromoCode.rejected, (state, action) => {
      state.error = action.payload as string;
    });
  },
});

export const { clearBonusError } = bonusSlice.actions;
export default bonusSlice.reducer;
